import moment from 'moment';
import formatIsoDate from '@/services/general/formatIsoDate';
import { getAllAsync } from '@/api/mandatTiers';

export async function trouverMandatActif(client, dateRecherche) {
  if (!client || !dateRecherche) {
    return null;
  }

  const date = dateRecherche instanceof Date 
    ? dateRecherche 
    : new Date(dateRecherche);

  if (client.mandats.length === 0) {
    const mandats = await getAllAsync(client.id);
    client.mandats = mandats.data.result.items;
  }

  const mandatClient = trouverMandatDansMandats(client.mandats, date);
  if (mandatClient) {
    return mandatClient;
  }

  if (client.tiersParent && client.tiersParent.mandats) {
    const mandatParent = trouverMandatDansMandats(client.tiersParent.mandats, date);
    if (mandatParent) {
      return mandatParent;
    }
  }

  return null;
}

function trouverMandatDansMandats(mandats, date) {
  if (!mandats || mandats.length === 0) {
    return null;
  }
  return mandats.find((mandat) => {
    if (!mandat.dateDebut) {
      return false;
    }

    const dateDebut = mandat.dateDebut instanceof Date
      ? mandat.dateDebut
      : new Date(mandat.dateDebut);

    const dateFin = mandat.dateFin
      ? (mandat.dateFin instanceof Date ? mandat.dateFin : new Date(mandat.dateFin))
      : null;
    return dateDebut <= date && (!dateFin || dateFin >= date);
  }) || null;
}


export function dateAvantProchainMandatActif(client, dateVisu) {
  if (!dateVisu || !client) return null;

  const dateDebut = moment(dateVisu).toDate();
  let mandats = client.mandats;
  if ((!mandats || mandats.length === 0) && client.tiersParent) {
    mandats = client.tiersParent.mandat;
  }
  if (!mandats) return null;

  mandats = mandats.sort((a, b) => {
    const dateA = new Date(a.dateDebut);
    const dateB = new Date(b.dateDebut);
    return dateA - dateB;
  });
  const mandatApres = mandats.find(m => new Date(m.dateDebut) - dateDebut > 0);
  if (!mandatApres) return null;
  const dateFin = new Date(mandatApres.dateDebut);
  return formatIsoDate((moment(dateFin).add(-1, 'days')).toDate());
}